import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthInterceptor as MyIdAuthInterceptor } from '@wdpr/ra-angular-myid-login';
import { Observable } from 'rxjs';

import { SsrService } from '@finder/shared/services/ssr/ssr.service';

/**
 * Delegates to the third-party MyID auth interceptor in the browser only.
 * The block reads `location` and `localStorage`, which are unavailable during SSR.
 */
@Injectable()
export class MyIdAuthSsrInterceptor implements HttpInterceptor {
    private ssrService = inject(SsrService);
    private myIdAuthInterceptor = inject(MyIdAuthInterceptor);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.ssrService.isSSR()) {
            return next.handle(req);
        }

        return this.myIdAuthInterceptor.intercept(req, next);
    }
}
